var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScangreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 278,
    height: 41,
    viewBox: "0 0 278 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_6374_475)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 246,
    height: 9,
    rx: 4.5,
    fill: "#96DCA1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_6374_475)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 18,
    width: 238,
    height: 5,
    rx: 2.5,
    fill: "#96DCA1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_6374_475",
    x: 0,
    y: 0,
    width: 278,
    height: 41,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur_6374_475"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_6374_475",
    x: 16,
    y: 14,
    width: 246,
    height: 13,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_6374_475"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScangreen);
export default __webpack_public_path__ + "static/media/scangreen.0e1f842f3e4f1ca195a84b82cc39e200.svg";
export { ForwardRef as ReactComponent };